import type { SupportedCurrency } from "@/lib/currency";
import { detectUserCurrency } from "@/lib/currency";

const useUserCurrency = (): SupportedCurrency => detectUserCurrency();

export default useUserCurrency;
